'use strict';
angular.module('schoolLinqApp').directive('paging', function () {
	var controller = [
		'$scope',
		function ($scope) {
			var viewModel = getViewModel();
			$scope.vm = viewModel;

			$scope.$watch('itemArrayLength', function (newValue) {
				$scope.vm.pageArray = window.app.pageArray(Math.ceil($scope.itemArrayLength / $scope.itemsPerPage), 'Page ');

				// if we are here and the startIndex values are not in sync then
				// figure out the vm.startIndex and vm.currentPageIndex and set them
				// so that the correct page number gets selected on the HTML page.
				if ($scope.startIndex !== 0 && $scope.vm.startIndex === 0) {
					$scope.vm.currentPageIndex = $scope.startIndex / $scope.vm.itemsPerPage;
					$scope.vm.startIndex = $scope.startIndex;
				}
				// handle case where the only item on the last page is deleted
				let pageArrayMaxIndex = $scope.vm.pageArray.length > 0 ? $scope.vm.pageArray.length - 1 : 0;
				if (pageArrayMaxIndex < $scope.vm.currentPageIndex) {
					$scope.vm.currentPageIndex = pageArrayMaxIndex;
					$scope.vm.startIndex = $scope.vm.currentPageIndex * $scope.vm.itemsPerPage;
					$scope.startIndex = $scope.vm.startIndex;
					$scope.vm.setPageIndex($scope.vm.currentPageIndex);
				}

				$scope.vm.showPageNumbers = $scope.itemArrayLength <= parseInt($scope.pageThreshold);
			});

			function getViewModel() {
				var model = {
					startIndex: 0,
					currentPageIndex: 0,
					pageArray: window.app.pageArray(Math.ceil($scope.itemArrayLength / $scope.itemsPerPage), 'Page '),
					itemsPerPage: $scope.itemsPerPage,
					showPageNumbers: $scope.itemArrayLength <= parseInt($scope.pageThreshold),
				};

				function changePageMode(model) {
					model.showPageNumbers = !model.showPageNumbers;
					// prevent showing page numbers if we are over the pageThreshold
					if (model.showPageNumbers) model.showPageNumbers = $scope.itemArrayLength <= parseInt($scope.pageThreshold);
				}

				function setPageIndexInternal(model, pageIndex, doCallback) {
					if ($scope.control) {
						$scope.control.previousPageIndex = $scope.control.currentPageIndex;
					}

					if (typeof pageIndex !== 'undefined' && pageIndex >= 0) {
						model.startIndex = pageIndex * model.itemsPerPage;
						model.currentPageIndex = pageIndex;
					} else {
						if (typeof model.currentPageIndex === 'undefined' || model.currentPageIndex === null || model.currentPageIndex < 0) {
							model.currentPageIndex = 0;
						} else if (model.currentPageIndex > model.pageArray.length - 1) {
							model.currentPageIndex = model.pageArray.length - 1;
						}

						model.startIndex = model.currentPageIndex * model.itemsPerPage;
					}

					if ($scope.control) {
						$scope.control.currentPageIndex = model.currentPageIndex;
						$scope.control.startIndex = model.startIndex;
					}

					//Update the startindex of the main table.
					$scope.startIndex = model.startIndex;
					if ($scope.setPageCallback && doCallback) {
						$scope.setPageCallback();
					}
				}

				function setPageIndex(model, pageIndex) {
					setPageIndexInternal(model, pageIndex, true);
				}

				// this is called when you just need to set the Page Index (the user is backing out of changing the page)
				function setPageIndexBack(model, pageIndex) {
					setPageIndexInternal(model, pageIndex, false);
				}

				if ($scope.control) {
					$scope.control.currentPageIndex = model.currentPageIndex;
					$scope.control.previousPageIndex = model.currentPageIndex;
					$scope.control.startIndex = model.startIndex;
					$scope.control.setPageIndex = _.partial(setPageIndex, model);
					$scope.control.setPageIndexBack = _.partial(setPageIndexBack, model);
				}

				return angular.extend(model, {
					setPageIndex: _.partial(setPageIndex, model),
					setPageIndexBack: _.partial(setPageIndexBack, model),
					changePageMode: _.partial(changePageMode, model),
				});
			}
		},
	];

	return {
		scope: {
			itemArrayLength: '=',
			pageThreshold: '@',
			itemsPerPage: '=',
			startIndex: '=',
			columnsToConsume: '@',
			setPageCallback: '=',
			control: '=',
			resetOnChange: '@',
		},
		controller: controller,
		replace: true,
		restrict: 'E',
		require: 'ngModel',
		template: require('@ajs/templates/paging.html'),
		compile: function (element, attrs) {
			if (!attrs.columnsToConsume) {
				attrs.columnsToConsume = 11;
			}

			if (attrs.columnsToConsume !== 11) {
				element.removeClass('col-xs-11');
				element.addClass('col-xs-' + attrs.columnsToConsume);
			}

			if (!attrs.resetOnChange) {
				attrs.resetOnChange = true;
			} else {
				attrs.resetOnChange = attrs.resetOnChange.toLowerCase() === 'true';
			}
		},
	};
});
